import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
  Input,
} from '@angular/core';
import { NUMBER_DIGITS_8 } from '~shared/constants';

@Directive({
  selector: '[appIsVisible]',
})
export class IsVisibleDirective {
  @Input() keepMeTracked = false;
  @Output() isVisible = new EventEmitter<boolean>();
  @Output() isOnViewPort = new EventEmitter<boolean>();
  @Output() isNotOnViewPort = new EventEmitter<boolean>();

  private wasVisible = false;

  constructor(private el: ElementRef) {
  }

  @HostListener('window:scroll', [])
  @HostListener('window:load', [])
  onWindowScroll() {
    this.trackElementVisibility();
  }

  /**
   * Function that can also be called from components to register element visibility
   * @param el
   */
  trackElementVisibility(el?: any) {
    // The element is only tracked once when it's visible
    if (this.wasVisible && !this.keepMeTracked) {
      return;
    }

    const trackedEl = el
      ? (el.elementRef.nativeElement as HTMLElement)
      : (this.el.nativeElement as HTMLElement);

    const elementRect = trackedEl.getBoundingClientRect();
    const elementBottom: number = elementRect.bottom;

    // Out of the page layout
    if (!this.keepMeTracked && elementBottom <= 0) {
      return;
    }

    const partialVisibility = window.innerHeight * NUMBER_DIGITS_8; // element visibility by 20% of viewport
    const isVisible = 0 <= elementRect.top && elementRect.top < partialVisibility;

    // Nothing changed from last time we checked
    // Either still not visible OR still visible
    if (isVisible === this.wasVisible) {
      return;
    }

    // We should change the state and fire the event
    // 1. In case the item is now visible
    // 2. In case we wanna keep tracking of the visibility
    const shouldUpdateLastState = this.keepMeTracked || isVisible;
    if (!shouldUpdateLastState) {
      return;
    }

    this.wasVisible = isVisible;
    this.fireScrollEvent(isVisible);
  }

  private fireScrollEvent(isVisible: boolean): void {
    this.isVisible.emit(isVisible);
  }
}
